import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'monorepo-number-pad',
  templateUrl: './number-pad.component.html',
  styleUrls: ['./number-pad.component.scss'],
})
export class NumberPadComponent implements OnInit, OnChanges {
  @Input() count: number = 0;
  @Input() enableAddOrSub: boolean = false;
  @Input() enableDecimal: boolean = true;
  @Input() enableMinus: boolean = false;
  @Input() heading = 'number_pad.qty';
  @Input() enablePrevButton: boolean = true;
  @Input() enableNextButton: boolean = true;
  @Input() enableCancel: boolean = false;
  @Input() enableFractionButton: boolean = false;
  @Input() enableSave: boolean = false;
  @Output('countValue') countValueChange = new EventEmitter<number>();
  @Output() rowChange = new EventEmitter<string>();
  @Output() fractionButtonClick = new EventEmitter<void>();

  numberPadFirstLineNumbers: number[] = [7, 8, 9];
  numberPadSecondLineNumbers: number[] = [4, 5, 6];
  numberPadThirdLineNumbers: number[] = [1, 2, 3];

  rightArrowIcon = '/assets/common/right-arrow.svg';
  leftArrowIcon = '/assets/common/left-arrow.svg';
  deleteIcon = '/assets/common/delete.svg';
  addIcon = '/assets/common/add-icon.svg';
  subtractIcon = 'assets/common/subtract-icon.svg';
  displayValue = '';

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.displayValue = this.count.toString();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['count']) {
      this.count = changes['count'].currentValue;
      this.displayValue = this.count.toString();
    }
  }

  handleNumClick(num: number) {
    if (this.displayValue === '0') {
      this.displayValue = num.toString();
    } else {
      this.displayValue += num;
    }

    this.count = Math.round(parseFloat(this.displayValue) * 100) / 100;
    this.displayValue = this.count.toString();
    this.countValueChange.emit(this.count);
  }

  handlePrevClick() {
    this.rowChange.emit('prev');
  }

  handleNextClick() {
    this.rowChange.emit('next');
  }

  handleDeleteClick() {
    this.displayValue = this.displayValue.substring(0, this.displayValue.length - 1);
    const newLength = this.displayValue.length;
    if (newLength === 0) {
      this.displayValue = '0';
      this.count = 0;
      this.countValueChange.emit(this.count);
    } else {
      if (this.displayValue.charAt(newLength - 1) === '.') {
        this.count = parseFloat(this.displayValue.substring(0, newLength - 1));
      } else if (this.displayValue.charAt(newLength - 1) === '-') {
        this.count = 0;
      } else {
        this.count = parseFloat(this.displayValue);
      }
      this.countValueChange.emit(this.count);
    }
  }

  incrementCount() {
    this.count = this.count + 1;
    this.displayValue = this.count.toString();
    this.countValueChange.emit(this.count);
  }

  decrementCount() {
    if (this.count > 0) {
      this.count = this.count - 1;
      this.displayValue = this.count.toString();
      this.countValueChange.emit(this.count);
    }
  }

  decimalClick() {
    if (!this.displayValue.includes('.')) {
      this.displayValue += '.';
    }
  }

  minusClick() {
    if (this.displayValue[0] !== '-') {
      this.displayValue = '-' + this.displayValue;
    }
    this.count = Math.round(parseFloat(this.displayValue) * 100) / 100;
    this.countValueChange.emit(this.count);
  }

  handleCancel() {
    this.modalController.dismiss();
  }

  handleFractionButtonClick() {
    this.fractionButtonClick.emit();
  }

  handleSave() {
    this.modalController.dismiss(this.count);
  }
}
